<template>
  <div :class="$style.container">
    <app-button :class="$style.exportButton" icon="DownloadFile" size="small" type="border" @click="onExport">
      Экспорт в csv
    </app-button>
    <h5 class="text-center mb-8">Между условиями логическое ИЛИ</h5>

    <div class="vx-col w-full flex justify-center" v-if="$can('rp.tariffs', 'write')">
      <vs-button type="flat" class="mr-2" @click="onAdd">Добавить</vs-button>
      <vs-button type="filled" color="success" @click="onSave">Сохранить</vs-button>
    </div>

    <div v-if="submitError" :class="$style.error">{{ submitError }}</div>

    <div :class="$style.list">
      <div
        :class="[$style.row, value.isRemoved && $style.rowRemoved, value.isNew && $style.rowNew]"
        v-for="value in extraValues"
        :key="value.id"
      >
        <template v-if="value.isNew">
          <div :class="$style.type">
            <elsa-v-select
              :options="extraValuesTypes"
              v-model="value.original.type_value"
              label="label"
              :reduce="item => item.value"
              :clearable="false"
              htmlLabel="Тип условия"
            />
          </div>

          <div :class="$style.apartments">
            <elsa-v-select
              v-if="value.original.type_value === 2"
              v-model="value.original.list"
              :options="apartments"
              label="account_number"
              :reduce="item => item.account_number"
              htmlLabel="Лицевые счета"
              multiple
              style-type="multiline"
              :loading="!apartments.length"
            >
            </elsa-v-select>
            <div v-if="value.original.type_value === 1" class="flex">
              <elsa-v-select
                class="w-full mr-2"
                v-model="value.original.from"
                label="account_number"
                :options="apartments"
                :reduce="item => item.account_number"
                :append-to-body="true"
                :clearable="false"
                :searchable="true"
                html-label="От"
                :loading="!apartments.length"
              />
              <elsa-v-select
                class="w-full"
                v-model="value.original.to"
                label="account_number"
                :options="apartments"
                :reduce="item => item.account_number"
                :append-to-body="true"
                :clearable="false"
                :searchable="true"
                html-label="До"
                :loading="!apartments.length"
              />
            </div>
          </div>

          <div :class="$style.value">
            <vs-input class="w-full" label="Тариф" v-model="value.original.value" />
          </div>

          <div :class="$style.date">
            <elsa-v-datepicker
              label="Действует c"
              v-model="value.original.start_date"
              view-format="LLLL yyyy"
              :datepicker-props="{minimumView: 'month'}"
            />
          </div>

          <div :class="$style.date">
            <elsa-v-datepicker
              label="Действует по"
              v-model="value.original.end_date"
              view-format="LLLL yyyy"
              :datepicker-props="{minimumView: 'month'}"
            />
          </div>
        </template>

        <template v-else>
          <div :class="$style.type">
            <vs-input
              class="w-full"
              label="Тип условия"
              :value="extraValuesTypes.find(t => t.value === value.original.type_value).label"
              disabled
            />
          </div>

          <div :class="$style.apartments">
            <vs-input
              v-if="value.original.type_value === 2"
              class="w-full"
              label="Лицевые счета"
              :value="value.original.list ? value.original.list.join(', ') : ''"
              disabled
            />
            <div v-if="value.original.type_value === 1" class="flex">
              <vs-input class="w-full mr-2" label="От" v-model="value.original.from" disabled />
              <vs-input class="w-full" label="До" v-model="value.original.to" disabled />
            </div>
          </div>

          <div :class="$style.value">
            <vs-input class="w-full" label="Тариф" v-model="value.original.value" disabled />
          </div>

          <div :class="$style.date">
            <vs-input
              class="w-full"
              label="Действует c"
              :value="formatDate(value.original.start_date, 'LLLL yyyy')"
              disabled
            />
          </div>

          <div :class="$style.date">
            <vs-input
              class="w-full"
              label="Действует по"
              :value="formatDate(value.original.end_date, 'LLLL yyyy')"
              disabled
            />
          </div>
        </template>

        <div :class="$style.remove">
          <vs-button
            v-if="$can('rp.tariffs', 'write')"
            type="flat"
            size="large"
            icon-pack="feather"
            icon="icon-trash"
            color="danger"
            @click="onRemove(value)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import formatDate      from "@/client/helpers/formatDate";
import notifyHttpError from "@/mixins/notifyHttpError";
import parseDate       from "@/client/helpers/parseDate";
import modalContext    from "@/mixins/modalContext";
import exportToCSV     from "@/helpers/exportToCSV";

export default {
  name:   "TariffsExtraValuesPopup",
  props:  ['tariff', 'apartmentsLoader'],
  mixins: [notifyHttpError, modalContext],
  data() {
    let lastId = 1;
    const extraValues = this.tariff.tarifs_value
      .filter(value => value.type_value !== 0)
      .map(value => ({
        id:        lastId++,
        isRemoved: false,
        isNew:     false,
        isError:   false,
        original:  ({
          ...value,
          list:       value.list ? value.list.split(',').map(v => v.trim()) : null,
          start_date: parseDate(value.start_date),
          end_date:   parseDate(value.end_date),
        }),
      }));
    return {
      extraValuesTypes: [
        { value: 2, label: 'Квартиры из списка' },
        { value: 1, label: 'Интервал' },
      ],
      extraValues,
      lastId,
      submitError:      null,
      apartments:       [],
    };
  },
  computed: {},
  methods:  {
    formatDate,
    onRemove( value ) {
      if (value.isNew) {
        this.extraValues = this.extraValues.filter(extraValue => extraValue !== value);
      } else {
        value.isRemoved = !value.isRemoved;
      }
    },

    onAdd() {
      this.extraValues.unshift({
        id:        this.lastId++,
        isRemoved: false,
        isNew:     true,
        isError:   false,
        original:  {
          type_value: 2,
          list:       null,
          from:       null,
          to:         null,
          value:      null,
          start_date: new Date(),
          end_date:   null,
        },
      });
    },

    async onSave() {
      this.extraValues.forEach(value => {
        const v = value.original.value;
        const numValue = v ? +v.replace(/,/g, '.') : null;
        value.isError = numValue === null || isNaN(numValue);
      });

      if (this.extraValues.some(v => v.isError)) return;

      try {
        this.submitError = null;
        let somethingChanged = false;
        for (let i = 0; i < this.extraValues.length; i++) {
          const extraValue = this.extraValues[i];
          if (extraValue.isRemoved) {
            await this.$http.delete(`tarif_value/${extraValue.original.id}`, { params: { buildings_id: this.tariff.buildings_id } });
            somethingChanged = true;
          }
          if (extraValue.isNew) {
            const { original } = extraValue;
            const body = {
              buildings_id: this.tariff.buildings_id,
              tarifs_id:    this.tariff.id,
              ...original,
              value:      original.value.replace(',', '.'),
              list:       original.list ? original.list.join(',') : null,
              start_date: formatDate(original.start_date, 'yyyy-MM'),
              end_date:   formatDate(original.end_date, 'yyyy-MM'),
            };
            await this.$http.post('tarif_value', body);
            somethingChanged = true;
          }
        }
        this.modalResolve(somethingChanged);
      } catch (e) {
        this.submitError = e.response.data.message;
      }
    },
    onExport() {
      const fileName = `Доп. условия для тарифа ${this.tariff.name}.csv`;

      const template = [
        {
          header: 'Тип условия',
          render: ( row ) => this.extraValuesTypes.find(t => t.value === row.original.type_value).label,
        },
        {
          header: 'Лицевые счета',
          render: ( row ) => {
            if (row.original.type_value === 1) return `${row.original.from} - ${row.original.to}`;
            if (row.original.type_value === 2) return row.original.list.join(', ');
            return '';
          },
        },
        { header: 'Тариф', render: ( row ) => `"${row.original.value.replace('.', ',')}"` },
        { header: 'Действует c', render: ( row ) => formatDate(row.original.start_date, 'LLLL yyyy') },
        { header: 'Действует по', render: ( row ) => formatDate(row.original.end_date, 'LLLL yyyy') },
      ];

      exportToCSV({
        fileName,
        template,
        data: this.extraValues,
      });
    },
  },
  mounted() {
    this.apartmentsLoader.then(( { data } ) => {
      this.apartments = data;
    });
  },
};
</script>

<style lang="scss" module>
.container {
  position: relative;
}

.list {
  margin-top: 1em;
}

.row {
  display: flex;
  align-items: flex-start;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding: .5em 0 1em;
  margin: 0 -.25em;

  &:last-child {
    border-bottom: 0;
  }

  & > * {
    margin: 0 .25em;
    flex-shrink: 0;
  }
}

.rowRemoved {
  background: rgba(var(--vs-danger), .08);
}

.rowNew {
  background: rgba(var(--vs-success), .08);
}

.type {
  width: 180px;
}

.apartments {
  flex: 1;
}

.value {
  width: 100px;
}

.date {
  width: 130px;
}

.remove {
  padding-top: 15px;
}

.error {
  color: color(danger);
  text-align: center;
  margin: 1em 0;
}

.exportButton {
  position: absolute;
  right: 0;
  top: 0;
}
</style>
